import { pluralize } from '@/react/common/string-utils';

import { AlertRuleEnvironmentsResponse } from '../../types';

export function formatAlertRuleStatusTooltip(
  environments: AlertRuleEnvironmentsResponse
): string {
  const { total, active, error, notSupported, pending, excluded } =
    environments;
  const parts: string[] = [];
  if (active > 0) parts.push(`${active} active`);
  if (pending > 0) parts.push(`${pending} in progress`);
  if (error > 0) parts.push(`${error} failed`);
  if (notSupported > 0) parts.push(`${notSupported} not supported`);
  if (excluded > 0) parts.push(`${excluded} excluded`);
  return `${total} ${pluralize(total, 'environment')}${
    parts.length ? `: ${parts.join(', ')}` : ''
  }`;
}
